import React from "react";
import styled, { keyframes } from "styled-components";

const words = [
  "Svatby",
  "Firemní akce",
  "Oslavy",
  "Festivaly",
  "Party stany",
  "Catering",
  "Bartending",
];

const Track = () => (
  <ul className="track" aria-hidden="true">
    {words.map((word, i) => (
      <li key={word} className={i % 2 === 0 ? "solid" : "outline"}>
        {word}
        <span className="sep">✦</span>
      </li>
    ))}
  </ul>
);

const Marquee = () => {
  return (
    <Wrapper aria-label="Svatby, firemní akce, oslavy, festivaly, party stany, catering, bartending">
      <div className="lane">
        <Track />
        <Track />
      </div>
    </Wrapper>
  );
};

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Wrapper = styled.section`
  background: var(--clr-dark-1);
  border-top: 1px solid rgba(184, 115, 51, 0.35);
  border-bottom: 1px solid rgba(184, 115, 51, 0.35);
  overflow: hidden;
  padding: 1.4rem 0;

  .lane {
    display: flex;
    width: max-content;
    animation: ${scroll} 36s linear infinite;
  }
  &:hover .lane {
    animation-play-state: paused;
  }

  .track {
    list-style: none;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  li {
    display: flex;
    align-items: center;
    font-family: var(--ff-display);
    font-size: clamp(1.4rem, 3vw, 2.1rem);
    font-weight: 600;
    letter-spacing: 0.01em;
    white-space: nowrap;
    color: var(--clr-cream);
  }
  li.outline {
    font-style: italic;
    font-weight: 500;
    color: transparent;
    -webkit-text-stroke: 1px rgba(250, 244, 234, 0.55);
  }

  .sep {
    font-size: 0.85rem;
    color: var(--clr-accent);
    margin: 0 1.75rem;
    -webkit-text-stroke: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    .lane {
      animation: none;
    }
  }
`;

export default Marquee;
